import axios from "@/CommonDP/utils/request";
export function serialNo_rule_list() {
  return axios({ url: 'serialNo-rule/list' });
}
export function serialNo_rule_saveOrUpdate(data) {
  return axios({ url: 'serialNo-rule/saveOrUpdate', method: 'post', data });
}
export function serialNo_rule_details(ruleId) {
  return axios({ url: `serialNo-rule/details/${ruleId}` });
}
